import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';

export type ActionPriority = 'critical' | 'high' | 'medium' | 'low';
export type ActionFocusArea = 'technical' | 'on_page' | 'local' | 'off_page' | 'schema' | 'aeo' | 'conversion' | 'competitive';
export type ActionSource = 'seo' | 'gap' | 'content' | 'asset';

export interface ActionItem {
  id: string;
  source: ActionSource;
  focusArea: ActionFocusArea;
  priority: ActionPriority;
  title: string;
  description: string;
  effort: 'low' | 'medium' | 'high';
  status: string;
  quickAction?: { type: 'copy'; label: string; content: string };
  createdAt: string;
}

export const actionsApi = {
  getItems: (locationId: string) =>
    apiClient.get<ApiResponse<ActionItem[]>>('/actions', { params: { locationId } }).then((r) => r.data),
};
